import TranslationText from '@Components/Utilities/TranslationText';
import RegistrationView from '@Views/SSO/RegistrationView';
import MyRegistration from '@Components/SSO/MyRegistration';
import RegistrationForm from '@Components/Forms/RegistrationForm';
import BidderRegistration from '@Components/SSO/BidderRegistration';
import MyInvoicesView from '@Views/Invoice/MyInvoicesView';
import StolenEquipmentVendorView from '@Views/StolenEquipment/StolenEquipmentVendorView';
import WantToBuyView from '@Views/WantToBuy/WantToBuyView';
import WantToBuyListView from '@Views/WantToBuy/WantToBuyListView';
import FBOVendorInformationView from '@Views/FBO/FBOVendorInformationView';
import ServerInfo from '@Components/SSO/ServerInfo';
import Subscriptions from '@Components/SSO/Subscriptions';
import AccountMenu from '@Components/Account/AccountMenu';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import WebSavedSearches from '@Components/WebSavedSearches/WebSavedSearches';
import NotificationSettings from '@Components/SSO/NotificationSettings';
import QuoteRequests from '@Components/Quotes/QuoteRequests';
import MyConsignmentRequestsView from '@Views/ConsignmentQuote/MyConsignmentRequestsView';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { useState } from 'react';

const AccountLayoutView = (props) => {

    const components = {
        'RegistrationView': RegistrationView,
        'MyRegistration': MyRegistration,
        'RegistrationForm': RegistrationForm,
        'BidderRegistration': BidderRegistration,
        'MyInvoicesView': MyInvoicesView,
        'StolenEquipmentVendorView': StolenEquipmentVendorView,
        'Subscriptions': Subscriptions,
        'NotificationSettings': NotificationSettings,
        'WantToBuyView': WantToBuyView,
        'WantToBuyListView': WantToBuyListView,
        'FBOVendorInformationView': FBOVendorInformationView,
        'ServerInfo': ServerInfo,
        'WebSavedSearches': WebSavedSearches,
        'QuoteRequests': QuoteRequests,
        'MyQuoteRequests': QuoteRequests,
        'MyConsignmentRequestsView': MyConsignmentRequestsView,
        'MyAcceptedQuoteRequests': QuoteRequests,
        'Messages': QuoteRequests
    };

    const [activeTab, setActiveTab] = useState(props.AccountMenu?.ActiveTab);
    const ChildComponent = components[props.ChildComponent];
    const currentUser = useRecoilValue(atoms.currentUser);
    const currentSite = useRecoilValue(atoms.currentWebsite);
        
    return (
        <div>
            {props.ChildComponent === 'RegistrationView' || ((props.ChildComponent === 'BidderRegistration' || props.ChildComponent === 'NotificationSettings') && props.NewRegistration && (currentSite?.IsBidCallerAuctionSite || currentSite?.IsAuctionTimeAuctionSite)) || (props.ChildComponent === 'Subscriptions' && !currentUser.IsAuthenticated) ?
                <ChildComponent {...props} activeTab={activeTab} /> //activeTab needed for NotificationSettings
                :
                <div className='my-account-content'>
                    <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={<TranslationText tKey='Sandhills.TradePubWebSite.MVC.MyAccount' />} />
                    <div className='inner-wrap main-content'>
                        <div>
                            <div>
                                <h1 className='pagename'><TranslationText tKey='Sandhills.TradePubWebSite.MVC.MyAccount' /></h1>
                            </div>
                            <div className='cf'>
                                <AccountMenu {...props.AccountMenu} activeTab={activeTab}/>
                                <div className='account-main'>
                                    <ChildComponent {...props} isChild activeTab={activeTab}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
        </div>
    );
};

export default AccountLayoutView;
global.AccountLayoutView = AccountLayoutView;